import styled from 'styled-components';

export const StudentListContainer = styled.section`
  width: 100%;
  .ms-user-name {
    font-size: 1.8rem;
    font-weight: 400;
    width: auto;
    display: inline-block;
    margin-right: 5px;
  }
  .student-action-cell {
    width: 20%;
  }
  .students-filters {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;
  }
  .ac-search-input {
    border-radius: 8px;
    padding: 8px;
    width: 95%;
    border: solid 1px ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
  }
  .select-filters {
    width: 100%;
    border-radius: 8px;
    padding: 8px;
    color: black;
    font-size: 1rem;
    border: solid 1px ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
  }
  .boxFilter {
    width: 50%;
    display: flex;
    flex-direction: column;
  }
  .boxFilter2 {
    width: 60%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .label-filters {
    font-size: 1rem;
    margin-right: 30px;
  }
  .select-filters-check {
    transform: scale(1.5);
    width: 20px;
    margin: 0px;
  }
  .ms-user-lastName {
    font-size: 1.8rem;
    font-weight: 400;
    width: auto;
    display: inline-block;
  }
  .ms-links {
    width: 40%;
    display: inline-block;
  }
  .ms-content {
    width: 100%;
    display: flex;
  }
  .ms-info {
    width: 40%;
    display: inline-block;
  }
  .ms-user-scholarID {
    width: 100%;
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 10px;
    font-size: 1.8rem;
  }
  .selectable-section {
    width: 20%;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .selectable-text {
    font-size: 1.5rem;
  }
  .selectable-input {
    padding: 10px;
    width: 12px !important;
    height: 12px !important;
    -ms-transform: scale(2);
    -moz-transform: scale(2);
    -webkit-transform: scale(2);
    -o-transform: scale(2);
    transform: scale(2);
    padding: 10px;
  }
  .multipleAcceptSubmit {
    display: block;
    border-radius: 8px;
    height: 43px;
    width: 173px;
    font-size: 1.5rem;
    background-color: #5373fc;
    margin-left: 75px;
    color: var(--white-color);
  }
  .students-list {
    font-size: 1.6rem;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
  .export-excel-position {
    display: block;
    font-size: 1.6rem;
    font-weight: 500;
    display: flex;
    justify-content: space-around;
  }
  .admin-student-action-button {
    background-color: transparent;
    font-size: 1.7rem;
    border: none;
    position: relative;
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
    padding: 4px;
  }
  .admin-student-action-tooltip {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    margin-left: -60px;
  }
  .admin-student-action-button:hover .admin-student-action-tooltip {
    visibility: visible;
    transition: ease-in 2s;
  }
  .admin-student-action-icon-send {
    color: var(--link-color-blue);
    font-size: 2.3rem;
    align-self: center;
  }
  .admin-student-action-icon-delte {
    color: tomato;
    font-size: 2.3rem;
    align-self: center;
  }
  .admin-student-action-icon-export {
    color: green;
    font-size: 2.3rem;
    align-self: center;
  }
  .admin-student-action-icon-download {
    color: lightskyblue;
    font-size: 2.3rem;
    align-self: center;
  }
  .AdminUsersTtiles {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  .see-applicantions {
    font-size: 2rem;
    color: #2f54eb;
    font-weight: 700;
  }
  .ac-search-title {
    font-family: 'Cooper Md BT', serif;
    font-size: 16px;
  }
  .MuiTableHead-root {
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    color: #fff;
    border-radius: 8px;
  }
  .MuiTableCell-head {
    color: #fff;
    font-family: 'Cooper Md BT', serif;
    font-size: 16px;
  }
  .k-button-primary,
  .k-button.k-primary {
    background-color: #0f3f44;
    border: solid 1px #f3f4f6;
    border-radius: 12px;
    padding: 8px;
  }
  .gender-img {
    width: 50px;
    height: 50px;
    display: inline-block;
  }
  .gender-p {
    display: inline-block;
    transform: translateY(-20px);
  }
  k-button,
  k-primary {
    background-color: #0f3f44;
    border: solid 1px #f3f4f6;
    width: 100%;
  }
`;
export default null;
